import { render } from "./TaskCard.vue?vue&type=template&id=e2dd0e56"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"
script.render = render

export default script